import { useEffect, useState } from 'react'
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js'
import { Stripe, StripeCardNumberElement } from '@stripe/stripe-js'

export default function useStripeElements(): {
  stripe: Stripe | null
  areCreditCardInputsValid: boolean
  cardElement: StripeCardNumberElement | null
} {
  const [isNumberComplete, setIsNumberComplete] = useState(false)
  const [isExpiryComplete, setIsExpiryComplete] = useState(false)
  const [isCvcComplete, setIsCvcComplete] = useState(false)
  const stripe = useStripe()
  const elements = useElements()

  useEffect(() => {
    const cardElement = elements?.getElement(CardNumberElement)
    const expiryElement = elements?.getElement(CardExpiryElement)
    const cvcElement = elements?.getElement(CardCvcElement)

    if (!stripe || !cardElement || !expiryElement || !cvcElement) {
      return
    }

    cardElement?.on('change', e => setIsNumberComplete(e.complete))
    expiryElement?.on('change', e => setIsExpiryComplete(e.complete))
    cvcElement?.on('change', e => setIsCvcComplete(e.complete))

    return () => {
      cardElement?.off('change', () => setIsNumberComplete(false))
      cardElement?.off('change', () => setIsExpiryComplete(false))
      cardElement?.off('change', () => setIsCvcComplete(false))
    }
  }, [elements, stripe])

  return {
    stripe,
    areCreditCardInputsValid: isNumberComplete && isExpiryComplete && isCvcComplete,
    cardElement: elements?.getElement(CardNumberElement) ?? null,
  }
}
